export default __webpack_public_path__ + "static/media/tranqyl.118e70b0.png";